<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      ลืมรหัสผ่าน
    </div>
    <div class="mb-2">
      <v-btn @click="back" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="px-4 pt-2">
      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
            digits: 10,
            regex: /^[0][3-9][0-9]{4}[0-9]{4}$/,
          }"
          name="หมายเลขโทรศัพท์"
          v-slot="{ errors }"
        >
          <div class="text-center" style="font-size: 20px">
            กรอกหมายเลขโทรศัพท์ใหม่
          </div>
          <custom-input
            :center="true"
            v-model="input.phoneNumber"
            maxlength="10"
            dense
            numberOnly
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center">
        <v-btn :loading="saveloading" class="mt-2" @click="next" color="primary"
          >ถัดไป</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      // input: { phoneNumber: "" },
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
  },
  mounted() {
    // this.$store.state.phoneNumber = "";
  },
  methods: {
    back() {
      this.query.tab = "profile";
      this.query.view = "PointManager";
    },
    async next() {
      if (await this.$refs.observer.validate()) {
        this.$emit("nextstep");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>